import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="gear"
export default class extends Controller {
  static targets = [
    "gearSelect",
    "baseLoadContainer",
    "rangeLoadContainer",
    "rangeLoad"
  ]

  connect() {
    // Initialize state based on current selection
    if (this.hasGearSelectTarget) {
      this.onGearChange()
    }
  }

  onGearChange() {
    const option = this.gearSelectTarget.selectedOptions[0]
    if (!option) return

    const adjustable = option.dataset.adjustable === "true"
    let allowed
    try {
      allowed = JSON.parse(option.dataset.allowed || "[]")
    } catch(_) {
      allowed = []
    }

    if (adjustable) {
      this.showRangeLoad(allowed)
    } else {
      this.showBaseLoad()
    }
  }

  showBaseLoad() {
    this.baseLoadContainerTarget.classList.remove("hidden")
    this.rangeLoadContainerTarget.classList.add("hidden")

    // Ensure range select has no name so it doesn't submit
    if (this.hasRangeLoadTarget) this.rangeLoadTarget.name = ""
    // Ensure base_load has correct name
    const input = this.baseLoadContainerTarget.querySelector("input")
    if (input) input.name = "environment_gear[base_load]"

    // Required flags
    if (this.hasRangeLoadTarget) this.rangeLoadTarget.required = false
    if (input) input.required = true
  }

  showRangeLoad(allowed) {
    this.baseLoadContainerTarget.classList.add("hidden")
    this.rangeLoadContainerTarget.classList.remove("hidden")

    // Ensure base input doesn't submit
    const input = this.baseLoadContainerTarget.querySelector("input")
    if (input) input.name = ""

    // Build options from allowed
    if (this.hasRangeLoadTarget) {
      this.rangeLoadTarget.name = "environment_gear[range_load][]"
      // If there are no options yet or allowed changed, rebuild
      const current = Array.from(this.rangeLoadTarget.options).map(o => o.value)
      const allowedArr = Array.isArray(allowed) ? allowed : Object.values(allowed)
      if (JSON.stringify(current.sort()) !== JSON.stringify(allowedArr.map(String).sort())) {
        this.rangeLoadTarget.innerHTML = ""
        allowedArr.forEach(val => {
          const opt = document.createElement("option")
          opt.value = String(val)
          opt.textContent = String(val)
          this.rangeLoadTarget.appendChild(opt)
        })
      }

      // Reselect existing values on edit using data-selected
      const selectedJson = this.rangeLoadTarget.dataset.selected || "[]"
      let selectedValues = []
      try { selectedValues = JSON.parse(selectedJson).map(String) } catch(_) { selectedValues = [] }
      Array.from(this.rangeLoadTarget.options).forEach(o => {
        o.selected = selectedValues.includes(o.value)
      })

      // Required flags
      this.rangeLoadTarget.required = true
      if (input) input.required = false
    }
  }
}
